export const formatCurrency = (value) => {
  const num = parseFloat(value) || 0;
  return `£${num.toFixed(2)}`;
};

export const formatNumber = (value) => {
  return parseInt(value) || 0;
};